import React, {Component} from "react";
import PubSub from "pubsub-js";
import "./styles/rating2.css";
import AvForm from "js/components/pages/ReturnOrderPage/AvForm";
import {AvFeedback, AvGroup} from "availity-mobx-reactstrap-validation";
import {Label as FormLabel} from "reactstrap";
import Textarea from "js/components/pages/ReturnOrderPage/Textarea";
import {errorResponse, makeRequest, navigate, url} from "js/services/Network";
import AnonymousId from "js/services/AnonymousId";
import {getSnapshot} from "mobx-state-tree";
import analytics from "js/services/Analytics";
import {inject} from "mobx-react";
import AppContent from "js/components/AppContent";
import Constraint from "js/components/Constraint";

@inject('page')
export default class RatingSmiley2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      can_submit: false,
      error_message: '',
    }
  }

  componentDidMount() {
    const page = this.props.page;
    const emojis = document.querySelectorAll(".emoji");
    const selectedRating = document.getElementById("selected-rating");
    const modalEmoji = document.getElementById("modalEmoji");
    const modal = document.getElementById("thankYouModal");
    let currentRating = null;

// Event listener for emoji selection
    emojis.forEach((emoji) => {
      emoji.addEventListener("click", () => {
        emojis.forEach((e) => e.classList.remove("selected"));
        emoji.classList.add("selected");
        currentRating = emoji.getAttribute("data-rating");

        if (currentRating) {
          const emojiMap = {
            1: "😡",
            2: "😟",
            3: "😐",
            4: "🙂",
            5: "😍"
          };


          modalEmoji.textContent = emojiMap[currentRating] || "🙂";
          selectedRating.textContent = emojiMap[currentRating] || "🙂";
          this.setState({can_submit: true})
        }
        // selectedRating.textContent = currentRating;
      });
    });

// Event listener for "Send Rating" button
    document.getElementById("sendRatingButton").addEventListener("click", () => {
      const hallSelect = document.getElementById("hallSelect");
      const selectedHall = hallSelect.value;

      if (currentRating) {
        const emojiMap = {
          1: "😡",
          2: "😟",
          3: "😐",
          4: "🙂",
          5: "😍"
        };


        modalEmoji.textContent = emojiMap[currentRating] || "🙂";
        // modal.style.display = "flex"; // Show the modal

        // console.log("rating: ",currentRating, "comment: ", selectedHall)

        try {
          const response = makeRequest('capture-and-store-review', null, {
            rating: currentRating ?? 3,
            comment: selectedHall,
            order_uid: page.order_uid,
          });

          setTimeout(() => {
            modal.style.display = "none";
            currentRating = null;
            selectedRating.textContent = "None";
            emojis.forEach((e) => e.classList.remove("selected"));
          }, 2000);

        } catch (error) {
          page.error = errorResponse(error);
        }

      }
    });

// Close modal if clicking outside of it
    window.addEventListener("click", (event) => {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    });
  }

  render() {

    return (
      <>
        <div className="container">
              <div className="tw-flex tw-items-center tw-w-full tw-justify-between tw-max-w-xl tw-gap-2">
                <div className="emoji-container">
                  <span className="emoji" data-rating="1" data-label="Terrible">😡</span>
                  <span className="label">Terrible</span>
                </div>
                <div className="emoji-container">
                  <span className="emoji" data-rating="2" data-label="Not satisfied">😟</span>
                  <span className="label" style={{fontSize:"13px"}}>Not satisfied</span>
                </div>
                <div className="emoji-container">
                  <span className="emoji" data-rating="3" data-label="Okay">😐</span>
                  <span className="label">Okay</span>
                </div>
                <div className="emoji-container">
                  <span className="emoji" data-rating="4" data-label="Satisfied">🙂</span>
                  <span className="label">Satisfied</span>
                </div>
                <div className="emoji-container">
                  <span className="emoji" data-rating="5" data-label="Happy">😍</span>
                  <span className="label">Happy</span>
                </div>
              </div>
              <div id="feedback-result">Your rating: <span id="selected-rating">None</span></div>

              <AvForm>
                <AvGroup>
                  <FormLabel for="hall" className="float-start">Comment</FormLabel>
                  <Textarea id="hallSelect" name="hall" placeholder="Optional" />
                  <AvFeedback>Please provide a comment</AvFeedback>
                </AvGroup>
              </AvForm>

              {/*<button id="sendRatingButton">Send Rating</button>*/}
            </div>
        <div id="thankYouModal" className="modal">
              <div className="modal-content">
                <span className="close-button">&times;</span>
                <div className="modal-emoji" id="modalEmoji">🙂</div>
                <h3>Thank you for your feedback!</h3>
              </div>
            </div>
        {/*<div className="d-flex flex-row justify-content-center mt-2">*/}
        {/*  */}
        {/*</div>*/}
      </>
    )
  }

}
